import React from 'react';
import { st, classes } from './TextSubscriptionInfo.st.css';

export const TextSubscriptionInfo: React.FC = ({ children }) => (
  <span className={st(classes.root, {})}>{children}</span>
);
